/**
 * Determines the type of menu element.
 *
 * This function checks the provided element's class list to determine if it is a sub-menu or a mega-menu.
 *
 * @param {HTMLElement} el - The element to check.
 * @param {Object} params - Configuration parameters.
 * @param {Object} params.classMap - A map of CSS classes.
 * @param {string} params.classMap.hasSubMenu - The CSS class indicating a sub-menu.
 * @param {string} params.classMap.hasMegaMenu - The CSS class indicating a mega-menu.
 * @returns {string|null} - Returns 'sub-menu' if the element is a sub-menu, 'mega-menu' if it is a mega-menu, or null if neither.
 */
export default function getType(el, params) {
  if (!el || !params || !params.classMap) {
    console.error('Invalid arguments provided to getType');
    return null;
  }

  const { hasSubMenu, hasMegaMenu } = params.classMap;

  if (el.classList.contains(hasSubMenu.slice(1))) {
    return 'sub-menu';
  }

  if (el.classList.contains(hasMegaMenu.slice(1))) {
    return 'mega-menu';
  }

  return null;
}
